export enum GameType {
  Exhibition = 'Exhibition',
  Season = 'Season',
  Playoff = 'Playoff'
}
